import React, {useEffect, useState} from "react";
import ReactECharts from "echarts-for-react";
const UserByPlanChart = ({userByPlan = []}) => {
    const [typeId, setTypeId] = useState(1);
    const [planName, setPlanName] = useState([]);
    const [data, setData] = useState([]);
    useEffect(() => {
        const arrayPlanName = userByPlan.filter(x => x.TypeId === typeId).map(item => item.ServicePlanName);
        const arrayData = userByPlan.filter(x => x.TypeId === typeId).map(item => item.TotalUsers);
        setPlanName(arrayPlanName);
        setData(arrayData);
    }, [typeId, userByPlan]);
    const option = {
        tooltip: {
            trigger: "item",
            backgroundColor: "#fff",
            borderColor: "#ccc",
            borderWidth: 1,
            textStyle: {
                color: "#333",
                fontSize: 13
            },
            formatter: (params) => {
                return `
                      <div style="padding: 5px 10px">
                        <strong>${params.name}</strong><br/>
                        Users: <span style="color:#2f5aa2;font-weight:bold; font-size: 0.8rem">${params.value}</span>
                      </div>
                    `;
            }
        },
        grid: { left: "5%", right: "5%", bottom: "3%", containLabel: true },
        xAxis: { type: "value" },
        yAxis: {
            type: "category",
            data: planName,
        },
        series: [
            {
                name: "Users",
                type: "bar",
                barWidth: "40%",
                data: data,
                itemStyle: {
                    color: "#2f5aa2",
                    borderRadius: [0, 4, 4, 0]
                }
            }
        ]
    };

    return (
        <div className="card" style={{ height: "450px" }}>
            <div className="card-body">
                <div>
                    <h5>Users by Subscription Plan</h5>
                    <p className="fs-9 fw-semibold">Users across countries</p>
                </div>
                <ul className="nav nav-underline mb-3" role="tablist">
                    <li className="nav-item">
                        <a
                            className="nav-link active cursor-pointer"
                            data-bs-toggle="tab"
                            role="tab"
                            aria-selected="true"
                            onClick={() => setTypeId(1)}
                        >
                            Personal Plan
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link cursor-pointer"
                            data-bs-toggle="tab"
                            role="tab"
                            aria-selected="false"
                            onClick={() => setTypeId(2)}
                        >
                            Business Plan
                        </a>
                    </li>
                </ul>
                <div className="tab-content">
                    <ReactECharts className='w-100' option={option} style={{ height: 300 }} />
                </div>
            </div>
        </div>
    );
};
export default UserByPlanChart;
